import { Model } from '@vuex-orm/core'

export default class Notification extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'notifications'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      type: this.attr(null),
      params: this.attr(null),
      candidate_id: this.attr(null),
      job_id: this.attr(null),
      requisition_id: this.attr(null),
      assigned_user_id: this.attr(null),
      account_id: this.attr(null),
      message: this.attr(null),
      body_shurt: this.attr(null),
      read: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Notification.js